import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "src/utils/analytics";

// Fires a GA page_view on every route change. Rendered once at the App
// root so it covers the website, admin, and app routers alike.
const AnalyticsListener: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Deferred a tick so react-helmet-async's own effect (which sets
    // document.title for the new page) has already run — otherwise this
    // can read the previous page's title.
    const timer = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 0);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsListener;
